export default __webpack_public_path__ + "static/media/easyToUse.e0c6314b.png";